export enum ITamanhoProcesso {
    XSM = 1,
    SM = 2,
    MD = 3,
    LG = 4,
    XLG = 4,
    XXLG = 6,
    XXXLG = 7,
    XXXXLG = 8,
    CONTAGEM = 9
}